module.exports = __webpack_public_path__ + "static/media/ruokasalin-poyta.66971009.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/ruokasalin-poyta.jpg
 ** module id = 393
 ** module chunks = 0
 **/